// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fontSangBleuSunrise_6c91f2', '__fontSangBleuSunrise_Fallback_6c91f2'"},"className":"__className_6c91f2"};